var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.251 12.469C19.501 12.2419 18.7217 12.126 17.938 12.125C16.3929 12.1265 14.8926 12.6442 13.6753 13.5959C12.458 14.5476 11.5936 15.8787 11.2193 17.3778C10.845 18.8769 10.9823 20.4582 11.6094 21.8703C12.2365 23.2825 13.3174 24.4447 14.6805 25.1723C16.0436 25.8999 17.6107 26.1513 19.133 25.8864C20.6553 25.6216 22.0454 24.8557 23.0827 23.7105C24.12 22.5652 24.7449 21.1063 24.8582 19.5653C24.9715 18.0243 24.5667 16.4896 23.708 15.205",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0231 12.562L19.7061 9.89999",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.04 12.562L19.34 14.534",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.25cfc4eaf54a9d2c31a15ed9ed9291ca.svg";
export { ForwardRef as ReactComponent };